import React, { useMemo } from 'react';
import { CnBox } from '../../../../components/cn-box';
import { EntryPointsTags } from '../entry-points-tags';
import './index.scss';
export const EntryPointsContent = (props) => {
    const { onItemClick, dataSource } = props;
    const hasChildren = useMemo(() => {
        return dataSource?.some((item) => item.children);
    }, [dataSource]);
    if (!dataSource?.length)
        return null;
    if (!hasChildren) {
        return (React.createElement("div", { className: "cn-entry-points-content" },
            React.createElement(EntryPointsTags, { onItemClick: onItemClick, dataSource: dataSource })));
    }
    return (React.createElement(CnBox, { wrap: false, spacing: 12 }, dataSource?.map((item) => (React.createElement("div", { className: "cn-entry-points-content" },
        React.createElement("div", { className: "cn-entry-points-content-title" }, item.label),
        React.createElement(EntryPointsTags, { onItemClick: onItemClick, dataSource: item.children }))))));
};
